<script setup>
import { Swiper } from 'swiper'
import 'swiper/css/bundle'

defineProps({
  participants: {
    type: Array,
    default: () => []
  }
})

onMounted(() => {
  const swiper = new Swiper('.staffSwiper', {
    freeMode: true,
    spaceBetween: 12,
    // loop: true,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })
})
</script>

<template>
  <div v-if="participants.length" class="container mx-auto">
    <h2 class="px-4 xl:px-0 text-xl lg:text-4xl font-semibold font-sf-pro pb-1 lg:pb-6">
      Действующие лица
    </h2>
    <div class="w-full hidden lg:flex flex-wrap gap-8">
      <t-wrapper-staff
        v-for="(participant, index) in participants"
        :key="index"
        :participant="participant"
      />
    </div>
    <div class="block lg:hidden h-18">
      <div class="staffSwiper px-4 xl:px-0 overflow-hidden">
        <div class="swiper-wrapper py-3">
          <t-wrapper-staff
            v-for="(participant, index) in participants"
            :key="index"
            class="swiper-slide !w-fit h-15"
            :participant="participant"
          />
        </div>
      </div>
    </div>
  </div>
</template>
